import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function AgencyOperationsAdminVenueAreaTabs({
    overlay = false
}: React.PropsWithChildren<{
    overlay?: boolean
}>): React.ReactElement {

    const { currentItemId } = useAppState(state=>state.areas)
    const { currentItemId: currentTenatId } = useAppState(state=>state.tenants)

    return ( 
        <NavTabs
            overlay={overlay}
            parentId={currentItemId}
            urlRoot={`/venues/${currentTenatId}/areas`}
            tabs={{
                details: {
                    label: 'Area Overview',
                    icon: 'home',
                    route: ''
                },
                guidelines: {
                    label: 'Area Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                }
            }}
        />
    )

}